import { render, staticRenderFns } from "./workflowDialog.vue?vue&type=template&id=48deb2cc&"
import script from "./workflowDialog.vue?vue&type=script&lang=js&"
export * from "./workflowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports